import { render } from "./EmployeeApproveServiceReports.vue?vue&type=template&id=f8d756f8"
import script from "./EmployeeApproveServiceReports.vue?vue&type=script&lang=js"
export * from "./EmployeeApproveServiceReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__